(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-lumios-compare-mob"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const LABELS = {
      sky: 'Sky',
      glow: 'Glow',
      candle: 'Candle'
    };

    function closeAllDropdowns() {
      document.querySelectorAll('[data-compare-mob-pickers] .ra-lumios-compare-mob-select__trigger').forEach(function(t) {
        t.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll('[data-compare-mob-pickers] .ra-lumios-compare-mob-select__list').forEach(function(list) {
        list.hidden = true;
      });
    }

    if (!window.__lumiosCompareMobUiBound) {
      window.__lumiosCompareMobUiBound = true;
      document.addEventListener('click', function(e) {
        if (e.target.closest('.ra-lumios-compare-mob-select')) return;
        


        closeAllDropdowns();
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') 
          closeAllDropdowns();
        


      });
    }

    function syncRowTexts(sectionInner, state) {
      if (!sectionInner || !state) return;
      sectionInner.querySelectorAll('.ra-lumios-compare-mob-row').forEach(function(row) {
        var scr = row.querySelector('script.lumios-compare-mob-cells');
        if (!scr) return;
        var cells;
        try {
          cells = JSON.parse(scr.textContent.trim());
        } catch (e) {
          return;
        }
        var isModeRow = row.getAttribute('data-compare-row') === 'mode-comparison';
        row.querySelectorAll('.ra-lumios-compare-mob-row__text').forEach(function(el) {
          var col = el.getAttribute('data-col');
          var bulb = col === 'a' ? state.a : state.b;
          var v = cells[bulb];
          if (typeof v !== 'string') return;
          if (isModeRow) {
            el.classList.add('ra-lumios-compare-mob-row__text--rich');
            el.innerHTML = v;
          } else {
            el.classList.remove('ra-lumios-compare-mob-row__text--rich');
            el.textContent = v;
          }
        });
      });
    }

    function initPickers(root) {
      if (! root || root.dataset.compareMobReady) return;
      


      root.dataset.compareMobReady = 'true';

      const sectionInner = root.closest('[data-compare-mob-inner]');
      const slotA = root.querySelector('[data-slot="a"]');
      const slotB = root.querySelector('[data-slot="b"]');
      if (! slotA || ! slotB) return;
      


      const state = {
        a: 'sky',
        b: 'glow'
      };

      function getTrigger(slot) {
        return slot.querySelector('.ra-lumios-compare-mob-select__trigger');
      }

      function getList(slot) {
        return slot.querySelector('.ra-lumios-compare-mob-select__list');
      }

      function updateUI() {
        [slotA, slotB].forEach(function(slot, i) {
          var key = i === 0
            ? state.a
            : state.b;
          var trigger = getTrigger(slot);
          var labelEl = trigger.querySelector('.ra-lumios-compare-mob-select__label');
          trigger.dataset.bulb = key;
          labelEl.textContent = LABELS[key];
        });
        syncRowTexts(sectionInner, state);
      }

      function closeLocal() {
        [slotA, slotB].forEach(function(slot) {
          var t = getTrigger(slot);
          var list = getList(slot);
          t.setAttribute('aria-expanded', 'false');
          list.hidden = true;
        });
      }

      function setSlot(which, newVal) {
        var other = which === 'a'
          ? 'b'
          : 'a';
        if (newVal === state[other]) {
          state[other] = state[which];
        }
        state[which] = newVal;
        updateUI();
        closeLocal();
      }

      [slotA, slotB].forEach(function(slot) {
        var trigger = getTrigger(slot);
        var list = getList(slot);
        var which = slot.getAttribute('data-slot');

        trigger.addEventListener('click', function(e) {
          e.stopPropagation();
          var wasOpen = trigger.getAttribute('aria-expanded') === 'true';
          closeAllDropdowns();
          if (! wasOpen) {
            trigger.setAttribute('aria-expanded', 'true');
            list.hidden = false;
          }
        });

        list.querySelectorAll('.ra-lumios-compare-mob-select__opt').forEach(function(opt) {
          opt.addEventListener('click', function(e) {
            e.stopPropagation();
            var v = opt.getAttribute('data-value');
            if (v && (v === 'sky' || v === 'glow' || v === 'candle')) {
              setSlot(which, v);
            }
          });
        });
      });

      updateUI();
    }

    function scan() {
      document.querySelectorAll('[data-compare-mob-pickers]').forEach(initPickers);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', function(ev) {
      ev.target.querySelectorAll('[data-compare-mob-pickers]').forEach(function(root) {
        delete root.dataset.compareMobReady;
        initPickers(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
